import React, {useEffect, useState} from 'react';
import './App.css';
import firebase from "firebase/compat/app";
import "firebase/compat/analytics";
import {getAnalytics} from "firebase/analytics";
import {AuthProvider} from "./utils/AuthProvider";
import '@fontsource/inter';
import {Box, CssBaseline, CssVarsProvider, extendTheme, Stack, Typography} from "@mui/joy";
import {Router} from "./utils/Router";
import {FeedbackProvider} from "./utils/FeedbackContext";
import {isMobileDevice} from "./utils/Utils";

if (!firebase.apps.length) {
  const app = firebase.initializeApp({
    apiKey: "AIzaSyBScotiAZvC2SQ7YeDGARiy4aMiBKgqxhc",
    authDomain: "oasionthestreet.firebaseapp.com",
    projectId: "oasionthestreet",
    storageBucket: "oasionthestreet.firebasestorage.app",
    messagingSenderId: "947463761447",
    appId: "1:947463761447:web:94d2f4d5f1ba8decc42802",
    measurementId: "G-C7MXKST8N3"
  })
  getAnalytics(app);
}

const baseTheme = extendTheme();
const darkOnlyTheme = extendTheme({
  cssVarPrefix: "sidebar_",
  colorSchemes: {
    light: baseTheme.colorSchemes.light,
    dark: baseTheme.colorSchemes.dark,
  },
});

function App() {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    setIsMobile(isMobileDevice())
    console.info('\x1b[34m%s\x1b[0m', // \x1b[38;5;33m
        "\n\n" +
        "        Developed with <3 by\n" +
        "        DANIELE DI GREGORIO\n" +
        "      www.danieledigregorio.it\n")
  }, []);

  return (
      <div>
        <AuthProvider>
          <FeedbackProvider>
            <CssVarsProvider theme={darkOnlyTheme} defaultMode="light">
              <CssBaseline />
              <Box sx={{
                minHeight: '100%',
                maxWidth: '100vw',
                backgroundColor: "var(--joy-palette-background-body)",
              }}
              >
                {
                  isMobile ?
                      <MobileDeviceError />
                      :
                      <Router />
                }
              </Box>
            </CssVarsProvider>
          </FeedbackProvider>
        </AuthProvider>
      </div>
  );
}

export default App;


function MobileDeviceError() {
  return (
      <Stack p={3} textAlign="center" justifyContent="center" alignItems="center" sx={{height: "100dvh"}}>
        <Typography level="h3">
          Questa app non è supportata su dispositivi mobili.
        </Typography>
      </Stack>
  )
}